import { cn } from "@/utils/cn";
import useTranslation from "@babackapp/translations/use-translation";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
} from "@babackapp/ui/components/command";
import { CheckIcon } from "@radix-ui/react-icons";
import type { ElementType } from "react";

interface CommandCheckboxesOption {
  value: string;
  label: string;
  Icon?: ElementType;
}

interface CommandCheckboxesProps {
  options: CommandCheckboxesOption[];
  values: string[];
  onSelect: (option: string, isSelected: boolean) => void;
  onClear: () => void;
  inputPlaceholder: string;
}

export default function CommandCheckboxes({
  options,
  onSelect,
  onClear,
  inputPlaceholder,
  values,
}: CommandCheckboxesProps) {
  const t = useTranslation();
  return (
    <Command>
      <CommandInput placeholder={inputPlaceholder} />
      <CommandList>
        <CommandEmpty>{t("misc.noResultFound")}</CommandEmpty>
        <CommandGroup>
          {options.map((option) => {
            const isSelected = values.includes(option.value);

            return (
              <CommandItem
                key={option.value}
                onSelect={() => {
                  onSelect(option.value, isSelected);
                }}
              >
                <div
                  className={cn(
                    "mr-2 flex h-4 w-4 items-center justify-center rounded-sm border border-primary",
                    isSelected
                      ? "bg-primary text-primary-foreground"
                      : "opacity-50 [&_svg]:invisible",
                  )}
                >
                  <CheckIcon className={cn("h-4 w-4")} />
                </div>
                {option.Icon && (
                  <div className={"mr-1"}>
                    <option.Icon />
                  </div>
                )}
                <span>{option.label}</span>
              </CommandItem>
            );
          })}
        </CommandGroup>
        <CommandSeparator />
        <CommandGroup>
          <CommandItem
            onSelect={onClear}
            className="justify-center text-center"
          >
            {t("misc.filters.clear")}
          </CommandItem>
        </CommandGroup>
      </CommandList>
    </Command>
  );
}
